'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _lodash = require('lodash');

var _v = require('uuid/v4');

var _v2 = _interopRequireDefault(_v);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
/**
 * You create a LoadMonitor with a callback.
 * LoadMonitor issues callback tickets, to be called when the thing you're waiting for is loaded.
 * When all of the tickets have been called, it calls the onLoaded function.
 */


var LoadMonitor = function () {
  function LoadMonitor(onLoaded) {
    var _this = this;

    _classCallCheck(this, LoadMonitor);

    this.loaded = {};
    this.unloaded = {};

    this.registerLoad = function () {
      var id = (0, _v2.default)();
      _this.unloaded[id] = true;
      return function () {
        return _this.setLoaded(id);
      };
    };

    this.onLoaded = onLoaded;
  }

  _createClass(LoadMonitor, [{
    key: 'setLoaded',
    value: function setLoaded(id) {
      if (!this.unloaded[id]) {
        return;
      }

      delete this.unloaded[id];
      this.loaded[id] = id;

      if ((0, _lodash.size)(this.unloaded) === 0) {
        this.onLoaded();
      }
    }
  }]);

  return LoadMonitor;
}();

exports.default = LoadMonitor;